import { useTranslation } from "react-i18next";
import { NoResultsSection } from "./NoResultsSection";
import type { SxProps, Theme } from "~/common/mui";

interface Props {
  title: string;
  onReset: () => void;
  sx?: SxProps<Theme>;
}

export const OrderQuoteNoResults = ({ title, onReset, sx }: Props) => {
  const { t } = useTranslation();
  return (
    <NoResultsSection sx={sx}>
      <NoResultsSection.Title>{title}</NoResultsSection.Title>
      <NoResultsSection.Subtitle>{t("page.orderList.noResults.subtitle")}</NoResultsSection.Subtitle>
      <NoResultsSection.Image />
      <NoResultsSection.Button onClick={onReset}>{t("page.orderList.noResults.resetButton")}</NoResultsSection.Button>
    </NoResultsSection>
  );
};
